export const emptyGameDefinition = {
    version: 'v1.0',
    getRoundIndex: () => ({ pendingTurns: [], roundIndex: 0 }),
    applyRoundToGlobalState: () => ({}),
    getInitialGlobalState: () => ({}),
    getPlayerState: () => ({}),
    getPublicTurn: ({ turn }) => ({}),
    getStatus: () => ({
        status: 'pending',
    }),
    maximumPlayers: 100,
    minimumPlayers: 1,
    validateTurn: () => { },
    applyProspectiveTurnToPlayerState: () => ({}),
};
//# sourceMappingURL=empty.js.map